export default __webpack_public_path__ + "static/media/comunicacao.9d1bdbc2.png";